const chargePeriodDropdown = [
    { id: 'D', label: 'Day' },
    { id: 'M', label: 'Month' },
    { id: 'Y', label: 'Year' }
];

export default chargePeriodDropdown;